import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { animateScroll as scroll } from 'react-scroll';

import {
  Wrapper,
  Box,
  Items,
  Link,
} from './style';

import AppState from '../../states/AppState';

class Navigation extends Component {
  position(scrollTop, windowHeight) {
    if (this.wrapper) {
      const box = this.wrapper.getBoundingClientRect();
      if (scrollTop < 0) {
        return 'fixed-bottom';
      } else if (scrollTop > windowHeight - box.height) {
        return 'fixed-top';
      } else {
        return 'absolute';
      }
    }
  }

  render() {
    const { topTen } = AppState.data.sections;
    return (
      <Wrapper
        className={AppState.scrollTop > 5 && AppState.scrollTop < AppState.bodyHeight - (6 * AppState.rem) ? 'active' : 'inactive'}
        innerRef={(el) => {
          this.wrapper = el;
        }}
        position={this.position(AppState.scrollTop, AppState.windowHeight)}
      >
        <Items>
          <Box inline>
            <Link
              key={"intro"}
              className={AppState.activeNavItemIndex === 0 ? 'active' : 'inactive'}
              onClick={(evt) => {
                evt.preventDefault();
                const el = document.getElementsByName("Introduction")[0];
                const box = el.getBoundingClientRect();
                scroll.scrollMore(box.top + 1);
              }}
            >Introduction</Link>
            {topTen.lists.map((list, index) => list.appearsInBody && (
              <Link
                key={index}
                className={AppState.activeNavItemIndex === index + 1 ? 'active' : 'inactive'}
                onClick={(evt) => {
                  evt.preventDefault();
                  const el = document.getElementsByName(list.navHeading)[0];
                  const box = el.getBoundingClientRect();
                  scroll.scrollMore(box.top + 1);
                }}
              >
                {list.navHeading}
              </Link>
            ))}
          </Box>
        </Items>
      </Wrapper>
    );
  }
}



export default observer(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js